/*!
 * QOVO Reviews
 * ---------------------------------------------------------------------------
 * Anyone can write a review — no purchase required, no eligibility check.
 * Guests supply an email; dedup is handled server-side on submit.
 *
 * Rendering: the first page ships server-rendered from Liquid (see
 * snippets/qovo-reviews.liquid) so there is no layout shift on load. This
 * script only rebuilds #qv-rv-list once the visitor actually interacts
 * (search / rating filter / sort / photos toggle / pagination). At boot it
 * just hydrates state and wires events against the existing markup.
 *
 * Ordering: reviews are sorted newest-first at boot to match the Liquid
 * render, so a server-rendered card's data-idx maps onto the same array
 * entry the lightbox reads.
 *
 * Verified badge: rendered ONLY when a review carries a genuine
 * "verified purchase" tag. Never applied blanket.
 */
(function () {
  'use strict';

  var RV = window.__QOVO_RV;
  if (!RV) return;

  var BASE = (RV.reviewsUrl || '').replace(/\/$/, '');
  var AUTH = RV.auth || '';

  var ALL        = (RV.reviews || []).slice();
  var SUMMARY    = RV.summary || '';
  var HIGHLIGHTS = RV.highlights || {};
  var PAGE_SIZE  = RV.pageSize || 8;

  // Match the server render: newest first.
  ALL.sort(function (a, b) { return new Date(b.createdAt) - new Date(a.createdAt); });

  var rating     = 0;        // 0 = all
  var sort       = 'newest';
  var search     = '';
  var photosOnly = false;
  var page       = 1;
  var filtered   = ALL.slice();

  var pending    = [];       // locally-held photos, uploaded on submit
  var pendingSeq = 0;
  var galleryPhotos = [];

  function $(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return iso;
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  function stars(n, size) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" aria-hidden="true">' +
        '<polygon class="' + (i <= n ? 'qv-s-on' : 'qv-s-off') + '" ' +
        'points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></svg>';
    }
    return out;
  }

  function initials(name) {
    name = (name || '').trim();
    if (!name) return '?';
    var p = name.split(/\s+/);
    if (p.length === 1) return p[0].charAt(0).toUpperCase();
    return (p[0].charAt(0) + p[p.length - 1].charAt(0)).toUpperCase();
  }

  // Verified ONLY on a genuine verification tag — never blanket-applied.
  function isVerified(r) {
    if (!r || !r.tags || !r.tags.length) return false;
    return r.tags.join(',').toLowerCase().indexOf('verified purchase') > -1;
  }

  /* ---------------------------- Overlay hosting ----------------------------
     The dialog and lightbox are position:fixed. If any ancestor ever picks up
     a transform / filter / will-change (GSAP, parallax, animation wrappers),
     fixed positioning would resolve against that ancestor instead of the
     viewport. Moving them to <body> on first open removes that risk. We carry
     the section's CSS custom properties across so the styling survives. */

  var CSS_VARS = [
    '--qv-bg', '--qv-fg', '--qv-muted', '--qv-line', '--qv-line-soft', '--qv-accent',
    '--qv-surface', '--qv-solid', '--qv-solid-fg', '--qv-star', '--qv-star-off', '--qv-radius'
  ];

  function teleport(el) {
    if (!el || el.parentElement === document.body) return;
    var root = $('qovo-reviews');
    if (root && window.getComputedStyle) {
      var cs = window.getComputedStyle(root);
      CSS_VARS.forEach(function (name) {
        var val = cs.getPropertyValue(name);
        if (val && val.trim()) el.style.setProperty(name, val.trim());
      });
    }
    el.classList.add('qv-rv');
    document.body.appendChild(el);
  }

  /* ------------------------------ Summary ------------------------------ */

  function renderSummary() {
    var ul = $('qv-rv-summary-list');
    var moreBtn = $('qv-rv-summary-more');
    if (!ul) return;

    var lines = [];
    if (HIGHLIGHTS.bullets && HIGHLIGHTS.bullets.length) {
      lines = HIGHLIGHTS.bullets;
    } else if (SUMMARY) {
      lines = SUMMARY.split(/(?:[.!?])\s+/).map(function (l) { return l.trim(); }).filter(Boolean);
    }
    if (!lines.length) return;

    var MAX = 3;
    var showAll = false;

    function paint() {
      ul.innerHTML = '';
      (showAll ? lines : lines.slice(0, MAX)).forEach(function (l) {
        var li = document.createElement('li');
        li.textContent = l;
        ul.appendChild(li);
      });
      if (moreBtn) {
        moreBtn.hidden = lines.length <= MAX;
        moreBtn.textContent = showAll ? 'Show less' : 'Show more';
      }
    }

    paint();
    if (moreBtn) moreBtn.addEventListener('click', function () { showAll = !showAll; paint(); });
  }

  /* --------------------------- Photo strip ---------------------------- */

  function renderGallery() {
    galleryPhotos = [];
    ALL.forEach(function (r) {
      if (r.photos && r.photos.length) r.photos.forEach(function (u) { galleryPhotos.push(u); });
    });
    if (!galleryPhotos.length) return;

    var wrap = $('qv-rv-gallery');
    var strip = $('qv-rv-gallery-strip');
    if (!wrap || !strip) return;

    strip.innerHTML = galleryPhotos.map(function (url, i) {
      return '<img src="' + esc(url) + '" class="qv-rv__gallery-thumb" loading="lazy" ' +
        'width="92" height="92" alt="Customer photo" data-gi="' + i + '">';
    }).join('');
    wrap.hidden = false;

    strip.addEventListener('click', function (e) {
      var img = e.target.closest('.qv-rv__gallery-thumb');
      if (img) openLightbox(galleryPhotos, parseInt(img.dataset.gi, 10));
    });
  }

  /* ----------------------- Filter / sort / paint ---------------------- */

  function apply() {
    var list = ALL.slice();

    if (rating > 0) list = list.filter(function (r) { return r.rating === rating; });
    if (photosOnly) list = list.filter(function (r) { return r.photos && r.photos.length; });

    if (search) {
      var q = search.toLowerCase();
      list = list.filter(function (r) {
        return (r.title || '').toLowerCase().indexOf(q) > -1 ||
               (r.body || '').toLowerCase().indexOf(q) > -1 ||
               (r.customerName || '').toLowerCase().indexOf(q) > -1;
      });
    }

    if (sort === 'highest')     list.sort(function (a, b) { return b.rating - a.rating; });
    else if (sort === 'lowest') list.sort(function (a, b) { return a.rating - b.rating; });
    else                        list.sort(function (a, b) { return new Date(b.createdAt) - new Date(a.createdAt); });

    filtered = list;
    page = 1;
    paintPage();
  }

  function card(r, idx) {
    var photos = r.photos || [];
    var media = '<time class="qv-rv__date">' + fmtDate(r.createdAt) + '</time>';

    if (photos.length === 1) {
      media += '<img src="' + esc(photos[0]) + '" class="qv-rv__img-single" loading="lazy" ' +
        'width="180" height="180" alt="Photo from a customer review" data-idx="' + idx + '" data-pi="0">';
    } else if (photos.length > 1) {
      var extra = photos.length - 4;
      var tiles = photos.slice(0, 4).map(function (u, pi) {
        var isMore = pi === 3 && photos.length > 4;
        return '<img src="' + esc(u) + '"' +
          (isMore ? ' class="qv-rv__img-more" data-more="+' + extra + '"' : '') +
          ' loading="lazy" width="88" height="88" alt="">';
      }).join('');
      media += '<div class="qv-rv__img-grid" data-idx="' + idx + '" data-pi="0" role="button" tabindex="0" ' +
        'aria-label="View ' + photos.length + ' review photos">' + tiles + '</div>';
    }

    return '<article class="qv-rv__card" data-idx="' + idx + '">' +
      '<div class="qv-rv__card-who">' +
        '<span class="qv-rv__avatar">' + esc(initials(r.customerName)) + '</span>' +
        '<div>' +
          '<p class="qv-rv__name">' + esc(r.customerName || 'Anonymous') + '</p>' +
          (isVerified(r)
            ? '<span class="qv-rv__verified"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
              'stroke-width="3" width="10" height="10" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
              'Verified purchase</span>'
            : '') +
        '</div>' +
      '</div>' +
      '<div class="qv-rv__card-body">' +
        '<div class="qv-rv__card-stars">' + stars(r.rating, 14) +
          '<span class="visually-hidden">' + r.rating + ' out of 5 stars</span></div>' +
        (r.title ? '<h3 class="qv-rv__card-title">' + esc(r.title) + '</h3>' : '') +
        '<p class="qv-rv__card-text">' + esc(r.body) + '</p>' +
      '</div>' +
      '<div class="qv-rv__card-media" data-idx="' + idx + '">' + media + '</div>' +
    '</article>';
  }

  function paintPage() {
    var list = $('qv-rv-list');
    if (!list) return;

    var total = filtered.length;
    var start = (page - 1) * PAGE_SIZE;
    var end = Math.min(start + PAGE_SIZE, total);

    if (!total) {
      list.innerHTML = '<p class="qv-rv__empty-sub" style="padding:36px 0 0">' +
        'No reviews match that. Try clearing the filters.</p>';
    } else {
      list.innerHTML = filtered.slice(start, end).map(function (r, i) {
        return card(r, start + i);
      }).join('');
    }
    paintMeta(total, start, end);
  }

  function paintMeta(total, start, end) {
    if (total === undefined) {
      total = filtered.length;
      start = (page - 1) * PAGE_SIZE;
      end = Math.min(start + PAGE_SIZE, total);
    }
    var info = $('qv-rv-page-info');
    if (info) {
      info.textContent = total > 0
        ? (start + 1) + '–' + end + ' of ' + total + ' review' + (total !== 1 ? 's' : '')
        : '0 reviews';
    }
    var prev = $('qv-rv-prev');
    var next = $('qv-rv-next');
    if (prev) prev.disabled = page === 1;
    if (next) next.disabled = end >= total;
  }

  function scrollToList() {
    var el = $('qv-rv-list');
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
  }

  /* ------------------------------ Wiring ----------------------------- */

  var listEl = $('qv-rv-list');
  if (listEl) {
    listEl.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pi]');
      if (!t) return;
      var r = filtered[parseInt(t.dataset.idx, 10)];
      if (r && r.photos && r.photos.length) openLightbox(r.photos, parseInt(t.dataset.pi, 10) || 0);
    });
    listEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target.closest('[data-pi][role="button"]');
      if (!t) return;
      e.preventDefault();
      var r = filtered[parseInt(t.dataset.idx, 10)];
      if (r && r.photos && r.photos.length) openLightbox(r.photos, parseInt(t.dataset.pi, 10) || 0);
    });
  }

  var prevBtn = $('qv-rv-prev');
  var nextBtn = $('qv-rv-next');
  if (prevBtn) prevBtn.addEventListener('click', function () {
    if (page > 1) { page--; paintPage(); scrollToList(); }
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    if (page * PAGE_SIZE < filtered.length) { page++; paintPage(); scrollToList(); }
  });

  var countLink = $('qv-rv-count-link');
  if (countLink) countLink.addEventListener('click', scrollToList);

  var searchInput = $('qv-rv-search');
  if (searchInput) {
    var timer;
    searchInput.addEventListener('input', function () {
      var val = this.value;
      clearTimeout(timer);
      timer = setTimeout(function () { search = val.trim(); apply(); }, 250);
    });
  }

  var mediaToggle = $('qv-rv-media-toggle');
  if (mediaToggle) mediaToggle.addEventListener('click', function () {
    photosOnly = this.getAttribute('aria-pressed') !== 'true';
    this.setAttribute('aria-pressed', photosOnly ? 'true' : 'false');
    apply();
  });

  /* ------------------------------ Select ----------------------------- */

  function initSelect(root, onChange) {
    if (!root) return;
    var trigger = root.querySelector('.qv-select__trigger');
    var valueEl = root.querySelector('.qv-select__value');
    var items = Array.prototype.slice.call(root.querySelectorAll('.qv-select__item'));
    var active = -1;

    function highlight() {
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === active); });
    }
    function onDocClick(e) { if (!root.contains(e.target)) close(); }
    function onKey(e) {
      if (e.key === 'Escape') { close(); trigger.focus(); return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(items.length - 1, active + 1); highlight(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(0, active - 1); highlight(); }
      else if (e.key === 'Enter') { e.preventDefault(); if (active >= 0) select(items[active]); }
    }
    function open() {
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      active = items.findIndex(function (i) { return i.getAttribute('aria-selected') === 'true'; });
      highlight();
      document.addEventListener('click', onDocClick);
      document.addEventListener('keydown', onKey);
    }
    function close() {
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKey);
    }
    function select(item) {
      items.forEach(function (it) { it.setAttribute('aria-selected', it === item ? 'true' : 'false'); });
      root.dataset.value = item.dataset.value;
      if (valueEl) valueEl.textContent = item.textContent.trim();
      close();
      onChange(item.dataset.value);
    }

    trigger.addEventListener('click', function () {
      root.classList.contains('is-open') ? close() : open();
    });
    items.forEach(function (item) {
      item.addEventListener('click', function () { select(item); });
      item.addEventListener('mouseenter', function () { active = items.indexOf(item); highlight(); });
    });
  }

  initSelect($('qv-rv-rating-select'), function (v) { rating = parseInt(v, 10) || 0; apply(); });
  initSelect($('qv-rv-sort'), function (v) { sort = v; apply(); });

  /* ----------------------------- Lightbox ---------------------------- */

  var lbImages = [];
  var lbIndex = 0;

  function paintLightbox() {
    var img = $('qv-rv-lb-img');
    if (!img) return;
    img.src = lbImages[lbIndex];
    var count = $('qv-rv-lb-count');
    if (count) count.textContent = lbImages.length > 1 ? (lbIndex + 1) + ' / ' + lbImages.length : '';
    var multi = lbImages.length > 1;
    var p = $('qv-rv-lb-prev');
    var n = $('qv-rv-lb-next');
    if (p) p.hidden = !multi;
    if (n) n.hidden = !multi;
  }

  function openLightbox(images, start) {
    lbImages = images || [];
    lbIndex = start || 0;
    if (!lbImages.length) return;
    var lb = $('qv-rv-lb');
    if (!lb) return;
    teleport(lb);
    paintLightbox();
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    var lb = $('qv-rv-lb');
    var img = $('qv-rv-lb-img');
    if (lb) lb.hidden = true;
    if (img) img.src = '';
    if (!isModalOpen()) document.body.style.overflow = '';
  }

  function lbStep(delta) {
    if (!lbImages.length) return;
    lbIndex = (lbIndex + delta + lbImages.length) % lbImages.length;
    paintLightbox();
  }

  var lbEl = $('qv-rv-lb');
  var lbX = $('qv-rv-lb-x');
  if (lbX) lbX.addEventListener('click', closeLightbox);
  if (lbEl) lbEl.addEventListener('click', function (e) { if (e.target === lbEl) closeLightbox(); });
  var lbPrev = $('qv-rv-lb-prev');
  var lbNext = $('qv-rv-lb-next');
  if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbStep(-1); });
  if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbStep(1); });

  document.addEventListener('keydown', function (e) {
    var lb = $('qv-rv-lb');
    if (lb && !lb.hidden) {
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') lbStep(-1);
      else if (e.key === 'ArrowRight') lbStep(1);
      return;
    }
    if (e.key === 'Escape' && isModalOpen()) closeModal();
  });

  /* --------------------------- Write review -------------------------- */

  function isModalOpen() {
    var m = $('qv-rv-modal');
    return !!m && !m.hidden;
  }

  var lastFocus = null;

  function openModal() {
    var m = $('qv-rv-modal');
    if (!m) return;
    lastFocus = document.activeElement;
    teleport(m);
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    var first = m.querySelector('input[type="radio"], input[type="text"]');
    if (first) setTimeout(function () { first.focus(); }, 60);
  }

  function closeModal() {
    var m = $('qv-rv-modal');
    if (!m) return;
    m.hidden = true;
    var lb = $('qv-rv-lb');
    if (!lb || lb.hidden) document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  Array.prototype.forEach.call(document.querySelectorAll('#qv-rv-write-btn'), function (b) {
    b.addEventListener('click', openModal);
  });
  var cancelBtn = $('qv-rv-cancel');
  if (cancelBtn) cancelBtn.addEventListener('click', closeModal);
  var modalX = $('qv-rv-modal-x');
  if (modalX) modalX.addEventListener('click', closeModal);
  var modalEl = $('qv-rv-modal');
  if (modalEl) modalEl.addEventListener('click', function (e) { if (e.target === modalEl) closeModal(); });

  // Star picker
  (function () {
    var pick = $('qv-rv-starpick');
    if (!pick) return;
    var labels = Array.prototype.slice.call(pick.querySelectorAll('label'));
    var inputs = Array.prototype.slice.call(pick.querySelectorAll('input'));

    function paint(v) {
      labels.forEach(function (l, i) { l.classList.toggle('is-lit', i < v); });
    }
    labels.forEach(function (l, i) {
      l.addEventListener('mouseenter', function () { paint(i + 1); });
      l.addEventListener('mouseleave', function () {
        var checked = pick.querySelector('input:checked');
        paint(checked ? parseInt(checked.value, 10) : 0);
      });
    });
    inputs.forEach(function (inp) {
      inp.addEventListener('change', function () { paint(parseInt(this.value, 10)); });
    });
  })();

  // Photo picker — held locally, uploaded only on submit
  var uploadEl = $('qv-rv-upload');
  var fileEl = $('qv-rv-file');
  var thumbsEl = $('qv-rv-thumbs');

  if (uploadEl && fileEl) {
    uploadEl.addEventListener('click', function (e) {
      if (!e.target.closest('.qv-rv__thumb-x')) fileEl.click();
    });
    uploadEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileEl.click(); }
    });
    uploadEl.addEventListener('dragover', function (e) { e.preventDefault(); uploadEl.classList.add('is-drag'); });
    uploadEl.addEventListener('dragleave', function () { uploadEl.classList.remove('is-drag'); });
    uploadEl.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadEl.classList.remove('is-drag');
      takeFiles(e.dataTransfer.files);
    });
    fileEl.addEventListener('change', function () { takeFiles(fileEl.files); fileEl.value = ''; });
  }

  function takeFiles(files) {
    var room = 3 - pending.length;
    if (room <= 0) { setMsg('You can add up to 3 photos.', 'error'); return; }
    Array.prototype.slice.call(files, 0, room).forEach(function (f) {
      if (!/^image\/(jpeg|png|webp)$/.test(f.type)) { setMsg('Photos must be JPEG, PNG or WEBP.', 'error'); return; }
      if (f.size > 5 * 1024 * 1024) { setMsg('That photo is over 5 MB.', 'error'); return; }
      var reader = new FileReader();
      reader.onload = function (e) { addThumb(e.target.result, f.name); };
      reader.readAsDataURL(f);
    });
  }

  function addThumb(dataUrl, filename) {
    var id = 'p' + (pendingSeq++);
    pending.push({ id: id, dataUrl: dataUrl, filename: filename });
    if (!thumbsEl) return;
    var wrap = document.createElement('div');
    wrap.className = 'qv-rv__thumb';
    wrap.setAttribute('data-id', id);
    wrap.innerHTML = '<img src="' + dataUrl + '" alt="Photo to attach to your review">' +
      '<button type="button" class="qv-rv__thumb-x" data-id="' + id + '" aria-label="Remove photo">&times;</button>';
    thumbsEl.appendChild(wrap);
  }

  if (thumbsEl) thumbsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('.qv-rv__thumb-x');
    if (!btn) return;
    var id = btn.getAttribute('data-id');
    pending = pending.filter(function (p) { return p.id !== id; });
    var t = btn.closest('.qv-rv__thumb');
    if (t) t.remove();
  });

  function uploadPending() {
    if (!pending.length) return Promise.resolve([]);
    return Promise.all(pending.map(function (p) {
      return fetch(BASE + '/reviews/upload-image', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Keplin-Auth': AUTH },
        body: JSON.stringify({ image: p.dataUrl, filename: p.filename })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.url) return d.url;
          throw new Error('Photo upload failed: ' + ((d && d.error) || 'unknown error'));
        });
    }));
  }

  function setMsg(text, type) {
    var el = $('qv-rv-msg');
    if (!el) return;
    el.textContent = text;
    el.className = 'qv-rv__msg' + (type ? ' qv-rv__msg--' + type : '');
  }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.disabled = !!on;
    btn.textContent = on ? 'Submitting…' : 'Submit review';
  }

  // No coupon code here by design. A photo review earns a single-use code, but
  // it is minted and emailed only once a human approves the review, so all we
  // can promise at this point is that it is coming. rewardPending comes straight
  // from the submit response.
  function showDone(rewardPending, rewardPercent) {
    var dialog = document.querySelector('#qv-rv-modal .qv-rv__dialog');
    if (!dialog) { setMsg('Thanks — your review will appear once approved.', 'success'); return; }

    var reward = '';
    if (rewardPending) {
      var pct = (rewardPercent || 10) + '%';
      reward =
        '<div class="qv-rv__reward">' +
          '<p class="qv-rv__reward-label">Your reward is on its way</p>' +
          '<p class="qv-rv__reward-note">Thank you for adding a photo. As soon as your review is approved, ' +
            'we&rsquo;ll email you a <strong>' + pct + ' off</strong> code to use on your next order &mdash; ' +
            'keep an eye on your inbox.</p>' +
        '</div>';
    }

    dialog.innerHTML =
      '<div class="qv-rv__done">' +
        '<div class="qv-rv__done-tick" aria-hidden="true">✓</div>' +
        '<h3>Thank you</h3>' +
        '<p>Your review will appear once approved.</p>' +
        reward +
        '<div style="margin-top:24px"><button type="button" class="qv-btn qv-btn--ghost" id="qv-rv-done">Close</button></div>' +
      '</div>';

    var done = $('qv-rv-done');
    if (done) done.addEventListener('click', closeModal);
  }

  // UK postcode check, mirroring src/reviews/postcode.ts on the Worker. Client
  // side is for a fast, friendly error only — the server revalidates and is the
  // real gate. Keep the two in step if either changes.
  var UK_POSTCODE = /^(GIR 0AA|(?:[A-PR-UWYZ][0-9]{1,2}|[A-PR-UWYZ][A-HK-Y][0-9]{1,2}|[A-PR-UWYZ][0-9][A-HJKPSTUW]|[A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]) [0-9][ABD-HJLNP-UW-Z]{2})$/;
  function isUkPostcode(raw) {
    var c = String(raw || '').toUpperCase().replace(/\s+/g, '');
    if (c.length < 5 || c.length > 7) return false;
    return UK_POSTCODE.test(c.slice(0, -3) + ' ' + c.slice(-3));
  }

  // Surface the specific field the Worker rejected instead of a generic message.
  function fieldError(data) {
    if (!data) return '';
    if (data.fields) {
      for (var k in data.fields) {
        if (Object.prototype.hasOwnProperty.call(data.fields, k)) return k + ': ' + data.fields[k];
      }
    }
    return data.error || '';
  }

  var form = $('qv-rv-form');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();

    var btn = $('qv-rv-submit');
    if (btn && btn.disabled) return;

    var checked = form.querySelector('input[name="rating"]:checked');
    var starRating = checked ? parseInt(checked.value, 10) : 0;
    var name = ($('qv-rv-name') ? $('qv-rv-name').value.trim() : '') || RV.customerName || '';
    var email = ($('qv-rv-email') ? $('qv-rv-email').value.trim() : '') || RV.customerEmail || '';
    var postcode = $('qv-rv-postcode') ? $('qv-rv-postcode').value.trim() : '';
    var title = $('qv-rv-title') ? $('qv-rv-title').value.trim() : '';
    var body = $('qv-rv-body') ? $('qv-rv-body').value.trim() : '';

    if (!starRating) { setMsg('Please choose a star rating.', 'error'); return; }
    if (!name) { setMsg('Please enter your name.', 'error'); return; }
    // Email is required of everyone now, logged in or not: it is the only
    // channel the reward code goes out on.
    if (!email) { setMsg('Please enter your email address.', 'error'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setMsg('That email address does not look right.', 'error'); return;
    }
    if (!postcode) { setMsg('Please enter your postcode.', 'error'); return; }
    if (!isUkPostcode(postcode)) { setMsg('Please enter a valid UK postcode.', 'error'); return; }
    if (title.length < 3) { setMsg('Your headline needs at least 3 characters.', 'error'); return; }
    if (body.length < 10) { setMsg('Your review needs at least 10 characters.', 'error'); return; }

    setLoading(btn, true);
    setMsg('', '');

    uploadPending()
      .then(function (photoUrls) {
        return fetch(BASE + '/reviews/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Keplin-Auth': AUTH },
          body: JSON.stringify({
            productId: RV.productId,
            productHandle: RV.productHandle,
            productTitle: RV.productTitle,
            customerId: RV.customerId || '',
            customerName: name,
            email: email,
            postcode: postcode,
            rating: starRating,
            title: title,
            body: body,
            photos: photoUrls
          })
        }).then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, data: d }; });
        });
      })
      .then(function (res) {
        if (res.data && res.data.status === 'already_reviewed') {
          setMsg('You have already reviewed this product — thank you.', 'success');
          setLoading(btn, false);
          return;
        }
        if (!res.ok) {
          setMsg(fieldError(res.data) || 'Something went wrong. Please try again.', 'error');
          setLoading(btn, false);
          return;
        }
        showDone(res.data && res.data.rewardPending, res.data && res.data.rewardPercent);
      })
      .catch(function (err) {
        setMsg((err && err.message) || 'Network error. Please try again.', 'error');
        setLoading(btn, false);
      });
  });

  // ?review=1 deep-links straight into the form (handy for post-purchase emails)
  if (/[?&]review=1/.test(window.location.search)) {
    setTimeout(openModal, 600);
  }

  /* ------------------------------- Boot ------------------------------ */
  // Hydrate only. #qv-rv-list keeps its server-rendered markup until the
  // visitor filters, sorts, searches or paginates.
  renderSummary();
  renderGallery();
  paintMeta();
})();
